import { atom } from "jotai";
import { atomFamily } from "jotai/utils";

export type ConversationLockOpenState =
  | { status: "idle" }
  | { status: "pending" }
  | { status: "acquired" }
  | { status: "conflict"; lockerName: string; nonce: number };

export const conversationLockOpenStateAtomFamily = atomFamily(
  (_conversationId: string) =>
    atom<ConversationLockOpenState>({ status: "idle" }),
);

export const setConversationLockOpenStateAtom = atom(
  null,
  (
    _get,
    set,
    update: { conversationId: string; state: ConversationLockOpenState },
  ) => {
    set(conversationLockOpenStateAtomFamily(update.conversationId), update.state);
  },
);
